// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
}

.textinputs2pwebinar {
    border-radius: 10px;
    border: 1px solid #dd3a3a; 
    height: 38px; 
    width: 270px;
   
}



.textinputspwebinar {
    border-radius: 10px;
    border: 1px solid #dd3a3a00;
    display: block;
    height: 38px; 
    width: 290px;
   
}`, "",{"version":3,"sources":["webpack://./src/components/WebinarForm.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;;AAEhB;;;;AAIA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,YAAY;;AAEhB","sourcesContent":["input:focus {\n    outline:none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n}\n\n.textinputs2pwebinar {\n    border-radius: 10px;\n    border: 1px solid #dd3a3a; \n    height: 38px; \n    width: 270px;\n   \n}\n\n\n\n.textinputspwebinar {\n    border-radius: 10px;\n    border: 1px solid #dd3a3a00;\n    display: block;\n    height: 38px; \n    width: 290px;\n   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
